import { useCallback, useEffect, useState } from 'react'
import {
  esquecerPermissao,
  listarPermissoes,
  type DecisaoDePermissao,
} from '../features/app/desktop-permissoes.ts'
import { isDesktop } from '../lib/platform.ts'

/**
 * Preferências → Áudio e vídeo (SPEC-20260916-2335).
 *
 * Por ora: o que já foi respondido sobre microfone e câmera, com "Esquecer"
 * para o Orbind voltar a perguntar. No navegador quem guarda é o próprio
 * navegador, então a seção explica isso em vez de mentir uma lista vazia.
 */

const ROTULO: Record<string, { nome: string; icone: string }> = {
  microfone: { nome: 'Microfone', icone: 'fas fa-microphone' },
  camera: { nome: 'Câmera', icone: 'fas fa-video' },
}

export function AudioEVideoSecao() {
  const [decisoes, setDecisoes] = useState<DecisaoDePermissao[]>([])
  const [carregando, setCarregando] = useState(true)

  const recarregar = useCallback(async () => {
    setDecisoes(await listarPermissoes())
    setCarregando(false)
  }, [])

  useEffect(() => {
    void recarregar()
  }, [recarregar])

  if (!isDesktop()) {
    return (
      <section>
        <h3 className="prefs__section">Microfone e câmera</h3>
        <p className="perm-lista__vazio">
          No navegador, quem pergunta e guarda a permissão do microfone e da câmera é o próprio navegador — o controle
          fica no cadeado ao lado do endereço. No Orbind para computador, a permissão é perguntada aqui dentro e fica
          nesta lista.
        </p>
      </section>
    )
  }

  return (
    <section>
      <h3 className="prefs__section">Microfone e câmera</h3>
      {carregando ? (
        <p className="perm-lista__vazio">Carregando…</p>
      ) : decisoes.length === 0 ? (
        <p className="perm-lista__vazio">
          Nada respondido ainda. Na primeira chamada o Orbind pergunta, e a resposta aparece aqui.
        </p>
      ) : (
        <ul className="perm-lista">
          {decisoes.map((d) => {
            const r = ROTULO[d.tipo] ?? { nome: d.tipo, icone: 'fas fa-shield-alt' }
            return (
              <li key={`${d.origem}|${d.tipo}`} className="perm-lista__item">
                <i className={r.icone} aria-hidden />
                <span className="perm-lista__nome">
                  {r.nome}
                  <span className="perm-lista__origem">{d.origem}</span>
                </span>
                <span className={`perm-lista__estado perm-lista__estado--${d.permitido ? 'sim' : 'nao'}`}>
                  {d.permitido ? 'Permitido' : 'Bloqueado'}
                </span>
                <button
                  type="button"
                  className="ob-btn ob-btn--ghost"
                  onClick={() => void esquecerPermissao(d.origem, d.tipo).then(recarregar)}
                >
                  Esquecer
                </button>
              </li>
            )
          })}
        </ul>
      )}
    </section>
  )
}
